module.exports = __webpack_public_path__ + "img/man_teacher.d2067b57.png";